/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as React from "react";
import { connect } from "react-redux";
import { Tab, Container } from "semantic-ui-react";

import { routeCustomersSelector, routeIdSelector } from "@teamprevent/common/messaging/selectors";
import { CommonApplicationState } from "@teamprevent/common/commonApplicationState";

import { CaseConversation } from "./CaseConversation";

interface StateProps {
    caseId: string;
    subject: string;
    customerId: string;
    previewConversation: string;
    employeeName: string;
}

const CaseConversationTabContentUnconnected: React.FunctionComponent<StateProps> = ({ caseId, subject, customerId, previewConversation, employeeName }) => {
    return (
        <Container>
            <CaseConversation
                caseId={caseId}
                subject={subject}
                includeAllSubjects={true}
                showReply={true}
                customerId={customerId}
                previewConversation={!!(previewConversation)}
                employeeName={employeeName}
            />
        </Container>
    );
};

/**
 * @deprecated Replaced by CaseConversationTab when FeatureToggleNames.CaseConversationImprovements is toggled on
 */
export const OldCaseConversationTab = () => ({
    path: "/conversation",
    menuItem: "Conversation",
    render: () => <Tab.Pane><CaseConversationTabContent /></Tab.Pane>
});

const mapStateToProps = (state: CommonApplicationState): StateProps => {
    const ohCaseId = routeIdSelector(state);
    const ohCase = state.ohCases.find(c => c.id === ohCaseId);
    const employeeName = `${ohCase?.employeeFirstName} ${ohCase?.employeeLastName}`;
    return {
        caseId: ohCaseId,
        subject: state.router.query.subject,
        previewConversation: state.router.query.previewConversation,
        customerId: routeCustomersSelector(state),
        employeeName
    };
};

export const CaseConversationTabContent = connect(mapStateToProps)(CaseConversationTabContentUnconnected);
